
import './App.css';
import Dice from './Dice';


function App() {
  return (
    <div  id="root">
      <Dice />
    </div>
  );
}

export default App;
